import { render, staticRenderFns } from "./invoice-options-send-to-orm.vue?vue&type=template&id=b35433c0&scoped=true"
import script from "./invoice-options-send-to-orm.vue?vue&type=script&lang=js"
export * from "./invoice-options-send-to-orm.vue?vue&type=script&lang=js"
import style0 from "./invoice-options-send-to-orm.vue?vue&type=style&index=0&id=b35433c0&prod&scoped=true&lang=css"
import style1 from "./invoice-options-send-to-orm.vue?vue&type=style&index=1&id=b35433c0&prod&lang=css"
import style2 from "./invoice-options-send-to-orm.vue?vue&type=style&index=2&id=b35433c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35433c0",
  null
  
)

export default component.exports